import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from 'src/shared/utils/currency';
import { useStyles } from './styles';

type FormErrorMessageProps = {
  totalLimit: number;
};

const FormErrorMessage = ({ totalLimit }: FormErrorMessageProps) => {
  const { t } = useTranslation(['flexflow']);
  const classes = useStyles();
  const formatCompanyCurrency = formatCurrency();
  const employeeFlexflowLimit = formatCompanyCurrency(totalLimit);

  return (
    <Typography className={classes.errorMessage}>
      {t('configuration.form.total value cannot be more than total', {
        total: employeeFlexflowLimit
      })}
    </Typography>
  );
};
export default FormErrorMessage;
